import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";

const Chapter31 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>
                 {/* Chapter 31 */}
                <section id="section31" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">{language.chapter31Title}</h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter31Paragraph1}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter31Paragraph2}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter31Paragraph3}


                    </p>
                    <h3 className="drivers-handbook-subheading">{language.chapter31ListTitle}</h3>
                    <ol className="drivers-handbook-list">
                        <li>{language.chapter31List1}</li>
                        <li>
                            {language.chapter31List2}
                        </li>
                        <li>{language.chapter31List3} (4×4)</li>
                    </ol>
                </section>

        </>
    )

}

export default Chapter31;
